import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        user: false,
        fileBaseUrl:false
    },
    mutations: {
        // 登录
        login(state, user) {
            state.user = user;
        },
        // 退出
        logout(state) {
            state.user = false;
        },
        setFileBaseUrl(state,data){
            state.fileBaseUrl = data + '/';
        }
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js